
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin-cover",
      function () {
        return require("private-next-pages/signin-cover.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signin-cover"])
      });
    }
  